import React from 'react';
import './Cali.css'; 

const Valledupar = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKVP.pdf" target="_blank" rel="noreferrer">Aeropuerto Alfonso Lopez Pumarejo</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 02</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/PUKV2A.pdf" target="_blank" rel="noreferrer">PUKV2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/PUKV2A.pdf" target="_blank" rel="noreferrer">SEKB2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1F.pdf" target="_blank" rel="noreferrer">BUXE1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1F.pdf" target="_blank" rel="noreferrer">IRON1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/EDVA2F.pdf" target="_blank" rel="noreferrer">EDVA2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/EDVA2F.pdf" target="_blank" rel="noreferrer">UGOS2C</a></th>
          </tr>
                
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/PUKV2B.pdf" target="_blank" rel="noreferrer">PUKV2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/PUKV2B.pdf" target="_blank" rel="noreferrer">ASAX2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1G.pdf" target="_blank" rel="noreferrer">BUXE1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1G.pdf" target="_blank" rel="noreferrer">IRON1J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/EDVA2G.pdf" target="_blank" rel="noreferrer">EDVA2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/EDVA2G.pdf" target="_blank" rel="noreferrer">UGOS1D</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 02</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1K.pdf" target="_blank" rel="noreferrer">BUXE1K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1K.pdf" target="_blank" rel="noreferrer">EDVA3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1K.pdf" target="_blank" rel="noreferrer">IRON2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1K.pdf" target="_blank" rel="noreferrer">UGOS3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1K.pdf" target="_blank" rel="noreferrer">UMPU3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/EDVA1H.pdf" target="_blank" rel="noreferrer">EDVA1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/UGOS2E.pdf" target="_blank" rel="noreferrer">UGOS2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/UGOS2E.pdf" target="_blank" rel="noreferrer">IRON1K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/UGOS2E.pdf" target="_blank" rel="noreferrer">BUXE1M</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1L.pdf" target="_blank" rel="noreferrer">BUXE1L</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1L.pdf" target="_blank" rel="noreferrer">IRON1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1L.pdf" target="_blank" rel="noreferrer">UGOS1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1L.pdf" target="_blank" rel="noreferrer">UMPU1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/BUXE1L.pdf" target="_blank" rel="noreferrer">EDVA1J</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 02</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/RNP02.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/VOR02.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 20</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKVP/RNP20.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Valledupar;